import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, NotificationService, ProductCustomerDetails, TmsWebBaseEditCreateService } from 'tms-lib';

@Injectable({
  providedIn: 'root',
})
export class CustomerProductService extends TmsWebBaseEditCreateService<
  ProductCustomerDetails,
  ProductCustomerDetails
> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('CustomerProduct', $localize`Customer Products`, httpService, notificationService);
  }

  getCustomersForProduct(id: string): Observable<ProductCustomerDetails[]> {
    return this.httpService.get<ProductCustomerDetails[]>(`${this.apiUrl}/CustomersForProduct?id=${id}`);
  }
}
